var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrInterlining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.683,
    height: 14.125,
    viewBox: "0 0 17.683 14.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-interlining",
    transform: "translate(0.001 -2.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M9.737,5.473h9.578a.737.737,0,1,0,0-1.473H9.737a.737.737,0,0,0,0,1.473Z",
    transform: "translate(-2.37 -0.417)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M19.314,11H9.737a.737.737,0,1,0,0,1.473h9.578a.737.737,0,1,0,0-1.473Z",
    transform: "translate(-2.37 -2.26)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M19.314,18H9.737a.737.737,0,1,0,0,1.473h9.578a.737.737,0,1,0,0-1.473Z",
    transform: "translate(-2.37 -4.103)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M4.484,5.056a.368.368,0,0,0,.26-.629l-1.8-1.8a.737.737,0,0,0-1.042,0l-1.8,1.8a.368.368,0,0,0,.26.629H1.69V13.9H.368a.368.368,0,0,0-.261.629l1.8,1.8a.737.737,0,0,0,1.042,0l1.8-1.8a.368.368,0,0,0-.26-.629H3.163V5.056Z",
    transform: "translate(0)",
    fill: "#bbc6d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrInterlining);
export default __webpack_public_path__ + "static/media/fi-rr-interlining.e3e0e6d2.svg";
export { ForwardRef as ReactComponent };